const gmapModule = () => import(/* webpackChunkName: 'components/gmaps' */'../gmaps/gmapController');
const heightEqualizerModule = () => import(/* webpackChunkName: 'utils/heightEqualizer' */'../../utils/js/heightEqualizer');

import { genericFilterTpl } from './genericFilter/genericFilterTpl';
import { budgetTpl } from './budget/budgetTpl';
import { housingTpl } from './housing/housingTpl';
import { bedroomsNumberTpl } from './bedroomsNumber/bedroomsNumberTpl';
import { equipmentTpl } from './equipment/equipmentTpl';

import { BudgetView } from './budget/budget';
import FilterResume from '../filterResume/filterResume';

export const FiltersView = Backbone.View.extend({
  events: {
    'click .js-filterInput': 'setFilters',
    'click .js-resetAllFilters': 'resetAllFilters',
    'click .js-resetFilter': 'resetFilter',
    'click .js-filterOpener': 'loadFilter',
    'click .js-closeFilter': 'closeFilter',
    'click .js-submitFilter': 'submitFilter',
    'click .js-memorizeOpenTab': 'memorizeOpenTab'
  },

  initialize: function (options) {
    heightEqualizerModule().then(({heightEqualizer}) => {
      window.heightEqualizer = heightEqualizer;
    });

    this.setElement(options.element);

    this.model = options.model;
    this.mainEngineModel = this.model.get('mainSearch');
    this.temporaryModel = this.model.get('temporarySearch');
    this.filtersModel = this.model.get('filters');
    this.tempFilters = this.model.get('tempFilters');
    this.$filterBlock = $('.js-searchFilters-filterContent');
    this.$filterBlockContent = this.$filterBlock.parent();
    this.$filterBlockContainer = this.$filterBlockContent.parent();
    this.$filtersContainer = $('.js-searchFilters-globalContainer');
    this.currentThematic = '';
    this.wordings = SEARCH_SCRIPTS.WORDING_SEARCH;
    this.isFirstLoad = true;
    this.facetteCache = {}; // Gestion d'un cache pour afficher les facettes et limiter le nombre d'appels s'il n'y a pas de changements de critères
    this.newHousingType_tab = typeof PRODUCT_SCRIPTS === 'object' && PRODUCT_SCRIPTS.BRANDCODE === 'SP' ? 'maison' : 'cottage';
    this.isResetAllFilters = false;
    this.nbSecondaryFilters = 0;
    this.openFromMenu = false;
    this.allEquipmentOpened = false;
    this.allActivitiesOpened = false;

    this.scrollContainerWatch();

    if (typeof GMAP_SCRIPTS !== 'undefined') {
      this.initGmap();
    }

    this.checkActive();

    if ($('.js-filtersAutoClose').length) {
      this.initCloseFilters('js-filtersAutoClose');
    }

    if (GLOBAL_SCRIPTS.ABTEST_COMPARATOR === 'B') {
      this.CompareSpecificBehaviours();
    }

    this.initMobileSpecificBehaviours();
    if(SEARCH_SCRIPTS.GROUP === 'offer') {
      this.domainFilterTracking();
    }

    this.budgetView = new BudgetView({filtersModel: this.filtersModel});

    this.filtersResume = FilterResume.init(this.filtersModel);

    this.listenTo(dispatcher, 'search:filters:displayFilter', this.displayFilter);
    this.listenTo(dispatcher, 'search:filters:render', this.render);
    this.listenTo(dispatcher, 'search:filters:clearCache', this.clearFilterCache);
    this.listenTo(dispatcher, 'search:filters:resetBoxesHeight', this.resetFilterBoxHeight);
    this.listenTo(dispatcher, 'search:memoFilterForMobile', this.memorizeFilters);
    this.listenTo(dispatcher, 'search:filters:close', this.closeFilter);
    this.listenTo(dispatcher, 'search:filters:backToPreviousFilters', this.backToPreviousFilters);
    this.listenTo(dispatcher, 'search:filters:updateFilterContentScroll', this.updateFilterContentScroll);
    this.listenTo(dispatcher, 'search:filters:canIScroll', this.canIScroll);
    this.listenTo(dispatcher, 'search:filters:showMobileFilters', this.loadFilter);

    this.stopListening(dispatcher, 'search:filters:checkActive');
    this.listenTo(dispatcher, 'search:filters:checkActive', this.checkActive);

    this.stopListening(dispatcher, 'search:filters:updateCounter');
    this.listenTo(dispatcher, 'search:filters:updateCounter', this.updateCounter);
  },

  domainFilterTracking: function() {
    $('.js-filterCounter').on('click', () => {
      const nbValuesSelected = SEARCH_SCRIPTS.IS_FACETTE_BUDGET_SELECTED ?  this.$filterBlock.find('input:checked').length + 1 : this.$filterBlock.find('input:checked').length;
      Tracking.dataLayerPush({
        event: 'clickEvent',
        gaCategory: 'park comparator',
        gaAction: nbValuesSelected === 0 ? 'no': 'yes',
        gaLabel: nbValuesSelected
      });
    });
  },

  /**
   * Global GMap management
   */
  initGmap: function () {
    this.gmapFancyView = new FancyboxView({
      selector: '.js-open-map',
      fancyType: 'custom',
      options: {
        infobar: false,
        toolbar: false,
        buttons: ['close', 'fullScreen'],
        touch: {
          vertical: false,
          momentum: true
        },
        modal: true
      }
    });

    gmapModule().then(({MapController}) => {
      this.gmap = new MapController();
    });
  },

  canIScroll: function () {
    genericScrollTo.canIScroll(DEVICE.isMobile);
  },
  /**
   * Display filters management
   */
  displayFilter: function () {
    dispatcher.trigger('searchView:scrollToSearchForm');
  },

  /**
   * Triggering filter close on click on before element
   * @param {string} classname
   */
  initCloseFilters: function (classname) {
    $('.' + classname).on('mousedown', (event) => {
      if ($(event.target).hasClass(classname)) {
        this.closeFilter();
      }
    });
  },

  /**
   * Closing filter and removing opened class on opener element
   * @param {Event=} event
   */
  closeFilter: function (event) {
    const $body = $('body');
    if (event) {
      event.preventDefault();
      $.each(this.facetteCache, (key, facette) => {
        if (typeof facette === 'object') {
          const code = facette.code.toLowerCase();
          const isOpen = $(`.js-filterOpener[data-facette="${code}"]`).closest('.searchbar__filters__item').hasClass('opened');

          if (isOpen) {
            let overlayArea = () => {
              switch (facette.code) {
                case 'HOUSINGCATEGORY':
                  return 'accomodation';
                case 'NUMBEROFBEDROOMS':
                  return 'number of bedrooms';
                case 'PRICE':
                  return 'budget';
                case 'ACTIVITIES':
                  return 'activities';
                case 'CLASSIFICATIONCOMFORT':
                  return 'park classification';
                case 'EQUIPMENT':
                  return 'equipement';
                default:
                  return code;
              }
            };

            Tracking.dataLayerPush({
              event: 'cta',
              page_type: PAGE_SCRIPTS.page_template,
              area: `overlay ${overlayArea}`,
              cta_clicked: 'close'
            });
          }
        }
      });
    }

    $('.js-filterOpener').parent().removeClass('opened');
    this.$filtersContainer.removeClass('display');
    $body.removeClass('searchFiltersContainer-opened searchFiltersContainerLayer-opened searchFiltersContainerLayer-forceBG');
    $('#mainContainer').removeClass('searchFiltersOpened');
    genericScrollTo.canIScroll(DEVICE.isMobile);
    const offset = DEVICE.isMobile ? $('.js-searchForm-toggler').outerHeight() + 30 : 80;
    genericScrollTo.go('.resultList-Header', 500, offset);
  },

  /**
   * Management of the dynamics of filters linked to the search engine
   * @param {Event} event
   */
  setFilters: function (event) {
    // NB: because a user can click very quickly on several checkboxes, we must manage all the checkboxes checked during each click
    const $input = $(event.currentTarget);
    const facetteName = $input.data('facette').toUpperCase();
    const isFacetteHousing = facetteName === 'HOUSINGSPEC' || facetteName === 'HOUSINGCATEGORY';
    const $filterOpener = !isFacetteHousing ? $('#' + $input.data('facette') + '_opener') : $('#housingcategory_opener');
    const $selectedValueDisplayer = $filterOpener.find('span.selected');
    const $counterValueDisplayer = $filterOpener.find('.filter-button__counter');
    const selectionOrder = this.filtersModel.get('selectionOrder').filter(item => item !== $input.val());
    let nbValuesSelected = 0;
    let displayedValue = '';
    let arrValues = [];
    let filterHebergementsType = this.filtersModel.get('filterHebergementsType');

    // We get the selectionOrder from filters model and we push at the beginning (last pushed => first displayed )
    selectionOrder.unshift($input.val());

    // Update data to showed filter
    let arrFilterValues = [];

    $('.js-filterInput:checked[data-facette=' + facetteName.toLowerCase() + ']').each((index, element) => {
      const value = $(element).val();
      const label = $(element).parent().find('.form-label').html();

      // Add model values
      arrValues.push(value);

      // Default values to show
      arrFilterValues.push({
        'label': label,
        'value': value
      });
    });

    // Handling facette_new_housing_type_code exception to update comfort groupe code
    if (facetteName === 'HOUSINGCATEGORY') {
      // Updating active tab to handling facette refresh
      this.newHousingType_tab = $input.data('groupe').toLowerCase();

      $(arrFilterValues).each((index, item) => {
        // Memorizing selected status
        if (item.value !== 'ANIMALS' && item.value !== 'PMR') {
          filterHebergementsType[item.value].selected = true;
        }
      });
    }

    if (facetteName === 'HOUSINGSPEC') {
      $('.js-filterInput:checked[data-facette=housingspec]').each((index, element) => {
        const $element = $(element);

        Tracking.dataLayerPush({
          event: 'clickEvent',
          clickCode: 'clickSearchFilters',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'Accommodation filter',
          gaLabel: $element.val() === 'ANIMALS' ? 'Animals allowed' : $element.val() === 'PMR' ? 'PMR adapted' : '',
          gaValue: 1
        });
      });
    }

    // Update model datas
    this.filtersModel.set({[facetteName]: arrValues, 'lastModifiedFilter': facetteName, 'selectionOrder': selectionOrder});

    // Values to display assignment
    if (isFacetteHousing) {
      const $inputCheckedHousingSpec = $('.js-filterInput:checked[data-facette=housingspec]');
      const $inputCheckedHousingCategory = $('.js-filterInput:checked[data-facette=housingcategory]');
      const $inputChecked = $inputCheckedHousingSpec.length ? $inputCheckedHousingSpec : $inputCheckedHousingCategory;

      nbValuesSelected = $inputCheckedHousingSpec.add($inputCheckedHousingCategory).length;

      if ($inputChecked.length) {
        arrFilterValues.push({
          label: $inputChecked.siblings('.form-label').text(),
          value: $inputChecked.val()
        });
      }
    } else {
      nbValuesSelected = arrFilterValues.length;
    }

    displayedValue = nbValuesSelected === 1 ? arrFilterValues[0].label : `${nbValuesSelected} ${this.wordings.items_selected_label}`;

    $filterOpener.toggleClass('active', nbValuesSelected > 0);
    $selectedValueDisplayer.html(nbValuesSelected > 0 ? displayedValue : '');
    $counterValueDisplayer.html(nbValuesSelected > 0 ? nbValuesSelected : '');
    $counterValueDisplayer.closest('.filter-button').toggleClass('has-counter', nbValuesSelected > 0);
    $('.searchForm-submitMobileFilter').toggleClass('hasReset', nbValuesSelected > 0);

    if (GLOBAL_SCRIPTS.ABTEST_COMPARATOR === 'B') {
      this.handleNewFilters(nbValuesSelected);
    }

    if (DEVICE.isMobile) {
      FilterResume.update();
    }

    this.checkActive();
  },

  /**
   * Reset a single filter state
   * @param {Event} event
   */
  resetFilter: function (event) {
    event.preventDefault();

    const $currentTarget = $(event.currentTarget);
    const facetteName = $currentTarget.data('facette').toUpperCase();
    const $filterOpener = $(`#${facetteName.toLowerCase()}_opener`);
    const $selectedValueDisplayer = $filterOpener.find('span.selected');
    const $counterValueDisplayer = $filterOpener.find('.filter-button__counter');
    const newSelectionOrder = this.filtersModel.get('selectionOrder').filter(item => typeof item !== 'object'); // Remove deleted Budget from selection Order
    let inputChecked = facetteName === 'PRICE' ? $(`#js_facette_budget[name="facet[${facetteName}]"]`) : $(`.js-filterInput[name="facet[${facetteName}][]"]:checked`);

    this.filtersModel.set({'selectionOrder': newSelectionOrder});

    if (facetteName === 'HOUSINGCATEGORY') {
      inputChecked = $.merge($('.js-filterInput[name="facet[HOUSINGSPEC][]"]:checked'), inputChecked);
    }

    if (facetteName === 'PRICE') {
      dispatcher.trigger('facettes:budget:reset');
    } else {
      inputChecked.each((index, element) => {
        $(element).prop('checked', false);
      });

      $filterOpener.removeClass('active');
      $selectedValueDisplayer.html('');
      $counterValueDisplayer.html('');
      $counterValueDisplayer.closest('.filter-button').removeClass('has-counter');

      this.filtersModel.set({[facetteName]: [], 'lastModifiedFilter': facetteName});
      if (facetteName === 'HOUSINGCATEGORY') {
        this.filtersModel.set({['HOUSINGSPEC']: [], 'lastModifiedFilter': facetteName});
      }
    }

    $currentTarget.addClass('u-Hidden--forced');
    FilterResume.update();
    this.checkActive();
  },

  /**
   * Reset all filters state
   * @param {Event} event
   */
  resetAllFilters: function (event) {
    event.preventDefault();

    const facetteSelector = '.searchbar__filters__item.active';

    this.isResetAllFilters = true;
    dispatcher.trigger('filterModel:reset');

    $(facetteSelector).each((_index, element) => {
      $(element).removeClass('active').find('span.selected').html('');
      const $counterValueDisplayer = $(element).find('.filter-button__counter');
      $counterValueDisplayer.html('');
      $counterValueDisplayer.closest('.filter-button').removeClass('has-counter');
    });

    $(event.currentTarget).hide(0);
    $('.searchForm-submitContainer').removeClass('hasReset');
    $('.js-nbFilters').addClass('u-Hidden');

    this.loadFilter(event);
    this.filtersResume.update();
    loader.remove('.js-searchFilters-globalContainer');

    // Resetting to false in order to show filter if we open again
    this.isResetAllFilters = false;

    Tracking.dataLayerPush({
      event: 'cta',
      page_type: PAGE_SCRIPTS.page_template,
      area: 'reset filter',
      cta_clicked: 'click'
    });
  },

  /**
   * Checks if a filter is active and shows/hides reset buttons
   */
  checkActive: function () {
    const isActive = !!$('.searchbar__filters__item.active').length;

    $('.js-resetAllFilters').toggle(isActive);
    $('.js-submitFilter').parents('.searchForm-submitContainer').eq(0).toggleClass('hasReset', isActive);
    $('.searchForm-submitMobileFilter').toggleClass('hasReset', isActive);
  },

  /**
   * Update number of active secondary filters
   */
  updateNbSecondaryFilters: function () {
    const filters = this.filtersModel.getResume();
    const defaultBudgetValue = typeof SEARCH_SCRIPTS.DEFAULT_FILTERS_CHECKED_VALUES.PRICE !== 'undefined' ? SEARCH_SCRIPTS.DEFAULT_FILTERS_CHECKED_VALUES.PRICE : '';
    let nbFiltersActive = 0;

    $.each(filters, (key, value) => {
      if (key !== 'PROMOCODE' && key !== 'filterHebergementsType' && value.length) {
        if (key === 'PRICE') {
          if (defaultBudgetValue !== value || SEARCH_SCRIPTS.IS_FACETTE_BUDGET_SELECTED) {
            nbFiltersActive++;
          }
        } else {
          nbFiltersActive += value.length;
        }
      }
    });

    this.nbSecondaryFilters = nbFiltersActive;

    if (this.nbSecondaryFilters > 0) {
      $('.js-nbFilters').removeClass('u-Hidden').text(this.nbSecondaryFilters);
    } else {
      $('.js-nbFilters').addClass('u-Hidden');
    }

    if (GLOBAL_SCRIPTS.ABTEST_COMPARATOR === 'B') {
      this.handleNewFilters(this.nbSecondaryFilters);
    }
  },

  /**
   * Handling filters display
   * @param {Event} event
   */

  loadFilter: function (event) {
    this.openFromMenu = $(event.currentTarget).hasClass('filter-button');
    // Get params
    dispatcher.trigger('searchModel:updateSearchParams');
    const ajaxParams = this.model ? this.model.get('ajaxParametersCache') : {};
    const triggerTarget = (event && event.currentTarget) ? event.currentTarget.dataset.href : null;
    const datasInModel = typeof this.model.get('JSON_results') === 'object' ? this.model.get('JSON_results') : null;

    // call search only when filter are open
    if (this.openFromMenu && datasInModel !== null) {
      this.buildFilter(datasInModel.results, triggerTarget);
    } else {
      genericAjaxCall({
        ajaxUrl: SEARCH_SCRIPTS.URL_API_SEARCH,
        ajaxParams: ajaxParams,
        successCallback: (datas) => {
          this.buildFilter(datas.results, triggerTarget);
        },
        dataType: 'json',
        type: 'GET'
      });
    }
  },

  buildFilter: function (datas, triggerTarget) {
    this.$filterBlock.empty();
    const facets = ['housingcategory', 'numberofbedrooms', 'price', 'equipment', 'activities'];

    facets.forEach((facetteName) => {
      const facette = datas.filter[facetteName];
      const filtreSpecial = datas.filter.housingspec;
      const selectedValues = datas.selected[facetteName];
      const resultCount = datas.total;

      if (facette) { // Ensure facet exist and is valid
        // Build facet panel template
        switch (facetteName) {
          case 'price':
            // Enhance facet data with the selected values
            facette.selected = {
              min: typeof selectedValues.min !== 'undefined' && selectedValues.min.key !== '' ? parseInt(selectedValues.min.key) : parseInt(facette.values.min),
              max: typeof selectedValues.max !== 'undefined' && selectedValues.max.key !== '' ? parseInt(selectedValues.max.key) : parseInt(facette.values.max)
            };
            this.$filterBlock.append(budgetTpl(facette, SEARCH_SCRIPTS.WORDING_SEARCH));
            this.budgetView.initRangeSelector(facette);
            break;
          case 'housingcategory':
            this.$filterBlock.append(housingTpl(facette, filtreSpecial, SEARCH_SCRIPTS.WORDING_SEARCH, this.newHousingType_tab, resultCount));
            accordion.init('.js-searchFilters-filterContent .api_accordion');
            break;
          case 'numberofbedrooms':
            this.$filterBlock.append(bedroomsNumberTpl(facette, SEARCH_SCRIPTS.WORDING_SEARCH, resultCount));
            break;
          case 'equipment':
            this.$filterBlock.append(equipmentTpl(facette, SEARCH_SCRIPTS.WORDING_SEARCH, resultCount));
            break;
          default:
            this.$filterBlock.append(genericFilterTpl(facette, SEARCH_SCRIPTS.WORDING_SEARCH, resultCount));
            break;
        }
      }
    });

    if (DEVICE.isMobile) {
      FilterResume.update();
    }

    this.checkActive();

    if ($(triggerTarget).length) {
      $('#mainContainer').addClass('searchFiltersOpened');
      genericScrollTo.canIScroll(DEVICE.isMobile);

      // Scroll to clicked filter
      this.$filterBlock.scrollTop(0);
      this.$filterBlock.scrollTop($(triggerTarget).position().top);

      $('.js-toogleOpener').each((index, item) => {
        let isEquipement = $(item).prev('.searchFilters-filterBoxContainer[class*="equipment"').length > 0;
        this.setHeightSeeMore(isEquipement ? 'equipment' : 'activities');
      });
    }
  },

  /**
   * Displaying filter content
   * @param {string=} facetteName
   * @param {boolean} jsonUsable
   */
  render: function (facetteName, jsonUsable = true) {
    const event = {
      currentTarget: {
        dataset: {
          href: `#filter_${facetteName}`
        },
        facetteName: `${facetteName}`
      }
    }; // fake event for scrolling`

    this.loadFilter(event);
    dispatcher.trigger('filterModel:resetLastFilter'); // Reset las modified filter to avoid filter to re-open
  },

  /**
   * Set content scrollable if filter is hidden
   */
  updateFilterContentScroll: function () {
    const $filterContent = $('.js-searchFilters-filterContent');

    if ($filterContent.data('height_equalizer_initiated') !== 'undefined' && $filterContent.data('height_equalizer_initiated') === 1) {
      $filterContent.height('auto');
      $filterContent.removeClass('scrollContent');

      const searchFiltersHeight = $('#js-searchFilters').height();
      const contentFilterHeight = searchFiltersHeight + $filterContent.outerHeight(true);
      const windowHeight = window.innerHeight;

      if (contentFilterHeight > windowHeight) {
        let newHeight = windowHeight - searchFiltersHeight - 80;
        $filterContent.height(newHeight);
        $filterContent.addClass('scrollContent');
      }
    }
  },

  /**
   * Handle horizontal scrolling and navigation buttons visibility
   */
  scrollContainerWatch: function () {
    const container = document.querySelector('.searchbar__filters');
    const content = document.querySelector('.searchbar__filters__content');
    const prevButton = document.querySelector('.searchbar__filters__nav--prev');
    const nextButton = document.querySelector('.searchbar__filters__nav--next');
    const scrollEvent = () => {
      const maxWidth = container.clientWidth;
      const maxScroll = content.scrollWidth;
      const currentScroll = content.scrollLeft;
      const scrollRight = maxWidth + currentScroll;

      prevButton.classList.toggle('is-visible', currentScroll > 0);
      nextButton.classList.toggle('is-visible', scrollRight < maxScroll);
    };

    content.addEventListener('scroll', scrollEvent);
    window.addEventListener('resize', scrollEvent);

    prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      content.scrollBy({left: -40, behavior: 'smooth'});
    });
    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      content.scrollBy({left: 40, behavior: 'smooth'});
    });

    // trigger first event to init.
    content.dispatchEvent(new CustomEvent('scroll'));
  },

  /**
   * Erasing cache
   */
  clearFilterCache: function () {
    this.facetteCache = {};
  },

  resetFilterBoxHeight: function () {
    heightEqualizer.reset(true, false);
    dispatcher.trigger('search:filters:updateFilterContentScroll');
  },

  setHeightSeeMore: function (filter) {
    const $equipmentItem = $('.searchFilters-filterBoxContainer--equipment');
    const $activities = $('.searchFilters-filterBoxContainer--activities');
    const $equipmentToggle = $('.js-toogleOpener[data-target="equipment"]');
    const $activitiesToggle = $('.js-toogleOpener[data-target="activities"]');
    let heigthOnLoad = 0;

    if (filter === 'equipment') {
      heigthOnLoad = Math.floor($('.equipmentCategory:first-of-type').outerHeight());
      if (!this.openFromMenu && this.allEquipmentOpened) {
        $('.equipmentCategory').each(function() {
          heigthOnLoad += Math.floor($(this).outerHeight());
          $equipmentToggle.html($equipmentToggle.data().labelhide);
        });
      } else {
        $equipmentToggle.html($equipmentToggle.data().labelsee);
      }

      $equipmentItem.css('max-height', heigthOnLoad + 'px');
    } else if (DEVICE.isMobile && filter === 'activities') {
      heigthOnLoad = Math.floor($('.searchFilters-filterItem').outerHeight() * 5 + 50);
      if (!this.openFromMenu  && this.allActivitiesOpened) {
        $activitiesToggle.html($activitiesToggle.data().labelhide);
      }
      $activities.css('max-height', heigthOnLoad + 'px');
    }

    $('.js-toogleOpener').off('click').on('click', (event) => {
      event.preventDefault();
      const $currentTarget = $(event.currentTarget);
      const currentTargetData = $currentTarget.data();
      const target = $currentTarget.data().target;

      this.allEquipmentOpened = $equipmentToggle.html() === $currentTarget.data().labelsee;
      this.allActivitiesOpened = $activitiesToggle.html() === $currentTarget.data().labelsee;

      let $el = '';
      let totalHeight = 0;
      let heigthToApply = 0;

      if (target === 'equipment') {
        $el = $('.searchFilters-filterBoxContainer--equipment');
        totalHeight = Math.floor($('.searchFilters-filterBoxContainer--equipment').outerHeight());

        $('.equipmentCategory').each(function(index) {
          totalHeight += Math.floor($(this).outerHeight() + (index === 0 ? 10 : 0));
        });

        heigthToApply = $el.css('max-height') === Math.floor($('.searchFilters-filterBoxContainer--equipment').outerHeight()) + 'px' ? Math.floor(totalHeight) : Math.floor($('.equipmentCategory:first-of-type').outerHeight());
      } else if (DEVICE.isMobile && target === 'activities') {
        $el = $('.searchFilters-filterBoxContainer--activities');
        totalHeight = $('.searchFilters-filterBoxContainer--activities .searchFilters-filterItem').length * 12;
        heigthToApply = Math.floor($('.searchFilters-filterItem').outerHeight() * 5 + 45);

        $('.searchFilters-filterBoxContainer--activities .searchFilters-filterItem').each(function() {
          totalHeight += Math.floor($(this).outerHeight());
        });

        heigthToApply = $el.css('max-height') !== Math.floor(totalHeight) + 'px' ? Math.floor(totalHeight) : heigthToApply;
      }

      /* set height */
      $el.css('max-height', heigthToApply + 'px');

      /* change label */
      $currentTarget.html(currentTargetData.labelsee === $currentTarget.html() ? currentTargetData.labelhide : currentTargetData.labelsee);
    });
  },

  /**
   * Handling specific behaviours for mobile
   */
  initMobileSpecificBehaviours: function () {
    $('.js-mobileValidation').off('click').on('click', (event) => {
      event.preventDefault();

      if (this.model.get('JSON_results')) {
        const urlSeo = this.model.get('JSON_results').results.uri;
        dispatcher.trigger('search:validateModelModifications', null, urlSeo);
      }

      this.closeFilter();
      this.model.set('memoForMobile', null);
      this.updateNbSecondaryFilters();
    });
  },

  CompareSpecificBehaviours: function () {
    $('.js-SortButton, .js-sortResult-item').on('click', (event) => {
      const $element = $(event.currentTarget);

      if (typeof $element.attr('data-label') !== 'undefined' && $element.attr('data-label') !== '') {
        $('.js-desktopSortList-current').text($element.attr('data-label'));
      }
      $('#desktopSortList').toggleClass('active');
    });

    $('.js-compareToggle').on('change', (event) => {
      const $input = $(event.currentTarget);
      let gaLabel = '';

      if ($input.prop('checked')) {
        gaLabel = 'Active';
        $input.attr('checked', 'checked').addClass('is-checked');
      } else {
        gaLabel = 'Inactive';
        $input.removeAttr('checked').removeClass('is-checked');
      }

      Tracking.dataLayerPush({
        event: 'clickEvent',
        gaCategory: 'park comparator',
        gaAction: 'toggle compare',
        gaLabel,
        gaValue: 1
      });
    });

    this.updateNbSecondaryFilters();
  },

  handleNewFilters: function (values = 0) {
    let iconClass = 'icon-filter-two';
    let classToDelete = 'icon-check';

    if (values > 0) {
      iconClass = 'icon-check';
      classToDelete = 'icon-filter-two';
    }

    if (DEVICE.isMobile) {
      $('.filter-button-mobile__icon').removeClass(classToDelete).addClass(iconClass);
    } else {
      $('.js-checkCounter').find('.filter-button__icon').removeClass(classToDelete).addClass(iconClass);
    }
  },

  updateCountrySites: function (url, newCountrySites) {
    let urlObj = new URL(url);
    let params = urlObj.searchParams;

    [...params.keys()].forEach(key => {
      if (key.startsWith('facet[COUNTRYSITE]')) {
        params.delete(key);
      }
    });

    newCountrySites.forEach((site, index) => {
      params.append(`facet[COUNTRYSITE][${index}]`, `l2_${site}`);
    });

    return urlObj.toString();
  },

  /**
   * Stocking a spectific state of search criteria
   * @param {string} facetteName
   * @param {string} currentSelected
   */
  memorizeFilters: function (facetteName, currentSelected) {
    const memoFilter = {
      filterValues: this.filtersModel.get(facetteName.toUpperCase()),
      facetteName: facetteName,
      label: currentSelected
    };

    this.model.set('memoForMobile', memoFilter);
  },

  /**
   * Reversing filters value
   */
  backToPreviousFilters: function () {
    const memorizedFilters = this.model.get('memoForMobile');
    const filtersValues = memorizedFilters.filterValues;
    const selectedLabel = memorizedFilters.label;
    const facetteName = memorizedFilters.facetteName;

    this.filtersModel.set({[facetteName.toUpperCase()]: filtersValues, 'backToPreviousFilters': true});
    $('#' + facetteName + '_opener .selected').html(selectedLabel);

    if (selectedLabel === '') {
      $('#' + facetteName + '_opener').removeClass('active');
    } else {
      $('#' + facetteName + '_opener').addClass('active');
    }

    // reset memorized values
    this.model.set({'memoForMobile': null}, {'silent': true});
    this.updateNbSecondaryFilters();
  },

  /**
   * Submit form management
   * @param {Event} event
   */
  submitFilter: function (event) {
    event.preventDefault();

    $('#mainContainer').removeClass('searchFiltersOpened');
    $('.searchFilters-toggler').removeClass('toggle-active');
    genericScrollTo.canIScroll(DEVICE.isMobile);
    dispatcher.trigger('sliderPhotos:init');
  },

  /**
   * Memorize current open tab
   * @param {Event} event
   */
  memorizeOpenTab(event) {
    this.newHousingType_tab = $(event.target).closest('.searchFilters-filterAccordionItem').data('label');
  },

  /**
   * Update filter button counter
   * @param {number} count
   */
  updateCounter: function (count, callback) {
    let mainLabelSingular = '';
    let mainLabelPlural = '';

    if (SEARCH_SCRIPTS.GROUP === 'housing') {
      if (DEVICE.isMobile) {
        mainLabelSingular = this.wordings.housing;
        mainLabelPlural = this.wordings.housings;
      } else {
        mainLabelSingular = this.wordings.filter_total_housing_single;
        mainLabelPlural = this.wordings.filter_total_housing_plural;
      }
    } else {
      if (DEVICE.isMobile) {
        mainLabelSingular = this.wordings.park;
        mainLabelPlural = this.wordings.parks;
      } else {
        mainLabelSingular = this.wordings.filter_single_results_label;
        mainLabelPlural = this.wordings.filter_total_results_label;
      }
    }

    let mainLabel = count > 1 ? mainLabelPlural : mainLabelSingular;

    if (!mainLabel.includes('%count%')) {
      mainLabel = `%count% ${mainLabel}`;
    }

    if (typeof callback !== typeof undefined) {
      return callback(mainLabel.replace('%count%', count));
    } else {
      $('.js-filterCounter').text(mainLabel.replace('%count%', count));
    }
  }
});